export default function stringIsPositiveWholeNumber(value) {
  if (!value) {
    return false;
  }
  return /^\d+$/.test(value);
}
